/* React hooks */
import { useRef } from "react";
/* Components */
import {Link} from "react-router-dom";
import FormAgencyFetch from "./FormAgencyFetch";
import useData from "../../../hooks/useData";
import CityNameZipSuggest from "../../../components/common/input-layout/CityNameZipSuggest";


export default function FormAgencyCreate({ legend }) {
    const { selectedCity } = useData();
    const cityListRef = useRef()

    const handleSubmit = (e) => {
        e.preventDefault()
        cityListRef.current.classList.add("active");
    }

    return (
        <>
            <form className="form">
                <legend>{legend}</legend>
                <p className="form-hint">Recherchez une agence existante par code postal ou ville avant d'en créer une nouvelle, pour éviter les doublons.</p>
                <CityNameZipSuggest type="actual" zipField="zipcode" cityField="city"/>
                <div className="agency-create-actions">
                    <button type="button" onClick={handleSubmit}>
                        <i className="fa fa-search"></i>
                        <span>Rechercher</span>
                    </button>
                    <span className="actions-divider">ou</span>
                    <button className="blue-button">
                        <Link to="/admin/agences/0/creer">
                            <i className="fa fa-plus"></i>
                            <span>Nouvelle agence</span>
                        </Link>
                    </button>
                </div>
            </form>
            <div ref={cityListRef} className="agency-list-search">
                <FormAgencyFetch legend="Recherche des agences existantes" zipcode={selectedCity?.zip} city={selectedCity?.name}/>
            </div>
        </>
    )
}
